var App = App || {};

App.Header = (function ($) {
    'use strict';
    function GlobalNav() {
        var navList = $(".global-nav-list");
        var navListLinks = navList.children("li:not(.global-nav-menu)").children("a, button");
        var navMenuBtns = $(".global-nav-menu-btn");
        var navMenuDropdowns = $(".global-nav-menu-dropdown");

        navList.on("mouseleave", function () {
            $(this).find(".global-nav-menu-dropdown").removeClass("open");
            $(this).find(".global-nav-menu-dropdown").find("a, button").attr("tabindex", -1);
        });

        navListLinks.on("click", function () {
            navMenuDropdowns.removeClass("open");
            navMenuDropdowns.find("a, button").attr("tabindex", -1);
        });

        navMenuBtns.on("click", function () {
            var itemId = $(this).attr("data-id");
            if ($('#' + itemId).hasClass("open")) {
                navMenuDropdowns.removeClass("open").attr("aria-hidden", true);
                navMenuDropdowns.find("a, button").attr("tabindex", -1);
            } else {
                navMenuDropdowns.removeClass("open").attr("aria-hidden", true);
                $('#' + itemId).toggleClass("open").attr("aria-hidden", false);
                $('#' + itemId).find("a, button").attr("tabindex", 0);
            }
        });
    }
    function MegaMenu() {

        let mmActive = false;
        const mmSpeed = 300;

        const mmContainer = $("header .header-primary > nav > ul");
        const mm1Trigger = mmContainer.children("li").children(".lvl-1-item");
        const mm1Items = mmContainer.find(".mega-menu").find("a");

        const mm2Trigger = mmContainer.find(".lvl-2-item");
        const mm3Items = mmContainer.find(".mega-menu-lvl-3 a");

        let mm1ActiveItems = [];
        let mm1ActiveItem = 0;

        mm1Items.attr("tabindex", -1);

        mmContainer.on("mouseleave", function () {
            mmActive = false;
            MegaMenuClose(mm1Trigger, mmSpeed);
        }).on("keydown", function (e) {
            if (e.key === "Tab") {
                mmActive = false;
                MegaMenuClose($(this).children("li").children("a, button"), 1);
            }
        });

        mm1Trigger.on("mouseenter", function () {
            MegaMenu1Open($(this), mmActive ? 1 : mmSpeed);
            mmActive = true;
        }).on("focus", function () {
            MegaMenu1Open($(this), 1);
            mmActive = true;
        }).on("blur", function () {
            if (mmActive === false) {
                MegaMenuClose($(this), 1);
            }
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    $(this).parent("li").next("li").children("a, button").trigger("focus");
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    mmActive = true;
                    mm1ActiveItems = [];
                    mm1ActiveItem = 0;
                    $(this).siblings(".mega-menu").find(".lvl-2-item:visible").each(function () { mm1ActiveItems.push(this); });
                    $(mm1ActiveItems[mm1ActiveItem]).trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    MegaMenuClose($(this), mmSpeed);
                    break;
            }
        });

        mm2Trigger.on("click", function () {            
            MegaMenu2Open($(this));
        }).on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    lvl2Right($(this));
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    lvl2Left($(this));
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    $(this).click();
                    var lvl3Menu = $(".mega-menu-lvl-3#" + $(this).attr("data-itemid"));
                    lvl3Menu.find("a").first().trigger("focus");
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    $(this).parents(".mega-menu-lvl-2").siblings(".lvl-1-item").trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, mmSpeed);
                    break;
            }
        });

        mm3Items.on("keydown", function (e) {
            switch (e.key) {
                case "ArrowRight":
                    e.preventDefault();
                    var thisIndex = $(this).attr("data-index");
                    if (thisIndex < ($(this).parents(".mega-menu-lvl-3").find("a").length - 1)) {
                        var nextIndex = parseInt(thisIndex) + 1;
                        $(this).parents(".mega-menu-lvl-3").find('a[data-index="' + nextIndex + '"]').trigger("focus");
                    }
                    else {
                        $(this).parents(".mega-menu-lvl-3").find('a[data-index="0"]').trigger("focus");
                    }
                    break;
                case "ArrowLeft":
                    e.preventDefault();
                    var thisIndex = $(this).attr("data-index");
                    if (thisIndex > 0) {
                        var prevIndex = parseInt(thisIndex) - 1;
                        $(this).parents(".mega-menu-lvl-3").find('a[data-index="' + prevIndex + '"]').trigger("focus");
                    }
                    else {
                        var lastIndex = $(this).parents(".mega-menu-lvl-3").find("a").length - 1;
                        $(this).parents(".mega-menu-lvl-3").find('a[data-index="' + lastIndex + '"]').trigger("focus");
                    }
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    $(this).parents(".mega-menu-lvl-2").find('.lvl-2-item[aria-expanded="true"]').trigger("focus");
                    break;
                case "Escape":
                    e.preventDefault();
                    var MenuButton = $(this).parents(".mega-menu").siblings("a, button");
                    MegaMenuClose(MenuButton, mmSpeed);
                    break;
            }
        });

    }

    function MegaMenu1Open(trigger, speed) {
        trigger.attr("aria-expanded", "true").addClass("open").siblings(".mega-menu").stop().slideDown(speed);
        MegaMenuClose(trigger.parents("li").siblings("li").children("a, button"), speed);
        trigger.parents(".lvl-1").addClass("open");
    }

    function MegaMenuClose(trigger, speed) {
        trigger.attr("aria-expanded", "false").removeClass("open").siblings(".mega-menu").stop().slideUp(speed);
        trigger.parents(".lvl-1").removeClass("open");
    }

    function MegaMenu2Open(trigger) {
        var allMenusLvl3 = trigger.parents(".mega-menu-lvl-2").find(".mega-menu-lvl-3");
        var menuLvl3 = trigger.parents(".mega-menu-lvl-2").find(".mega-menu-lvl-3#" + trigger.attr("data-itemid"));

        allMenusLvl3.removeClass("active");
        menuLvl3.addClass("active");

        trigger.attr("aria-expanded", "true").parent().siblings().find("a, button").attr("aria-expanded", "false");
    }

    function lvl2Right(trigger) {
        if (trigger.parent("li").index() < trigger.parents("ul.lvl-2").children("li.lvl-2-wrapper").length) {
            trigger.parent("li").next("li").children(".lvl-2-item").trigger("focus").click();
        }
        else {
            trigger.parents("ul.lvl-2").find(".lvl-2-item").first().trigger("focus").click();
        }
    }

    function lvl2Left(trigger) {
        if (trigger.parent("li").index() > 1) {
            trigger.parent("li").prev("li").children(".lvl-2-item").trigger("focus").click();
        }
        else {
            trigger.parents("ul.lvl-2").find(".lvl-2-item").last().trigger("focus").click();
        }
    }

    function MobileMenu() {

        const offcanvas = $("#header-mobile-menu");
        const levels = offcanvas.find(".mobile-menu-levels");
        const buttons = offcanvas.find("button[data-mobilemenu]");

        offcanvas.on("hidden.bs.offcanvas", function () {
            // reset
        });

        buttons.on("click", function () {

            const currentLevel = parseInt(levels.attr("data-level"));
            const currentItem = levels.find(`.mobile-menu-level[data-level="${currentLevel}"]`).find(".mobile-menu-level-item.active");

            const nextItem = $(`#${$(this).attr("aria-controls")}`);
            var nextLevel = parseInt(nextItem.parents(".mobile-menu-level").attr("data-level"));
            if (nextLevel == null || isNaN(nextLevel)) {
                nextLevel = 1;
            }

            currentItem.removeClass("active");
            nextItem.addClass("active");

            levels.attr("data-level", nextLevel);
            levels.parents(".mobile-menu").attr("data-level", nextLevel);
        });
    }

    return {
        GlobalNav: GlobalNav,
        MegaMenu: MegaMenu,
        MobileMenu: MobileMenu
    };

})(jQuery);